











import FilterListToggles from '@/components/FilterListToggles.vue'

export default
    components: { FilterListToggles }
   
